module.exports = __webpack_public_path__ + "static/media/chatbot.e8e3da50.png";